module.exports = __webpack_public_path__ + "static/media/_MIC2348.thumbnail.48e44f51.png";